export default "__VITE_ASSET__BJirensu__"